import {Component} from '@angular/core';
import {PercorsoVista} from '../contenitore-percorso/percorso-vista';

/** Feature 166, vista A (predefinita): una fila di card per riga, frecce fra le fasi, sottofasi impilate. */
@Component({
  selector: 'app-contenitore-percorso-orizzontale',
  templateUrl: './contenitore-percorso-orizzontale.component.html',
  styleUrls: ['./contenitore-percorso-orizzontale.component.scss'],
  standalone: false
})
export class ContenitorePercorsoOrizzontaleComponent extends PercorsoVista {}
